/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCustomerPromotions200ResponseItemsInner } from './GetCustomerPromotions200ResponseItemsInner';
import {
    GetCustomerPromotions200ResponseItemsInnerFromJSON,
    GetCustomerPromotions200ResponseItemsInnerFromJSONTyped,
    GetCustomerPromotions200ResponseItemsInnerToJSON,
    GetCustomerPromotions200ResponseItemsInnerToJSONTyped,
} from './GetCustomerPromotions200ResponseItemsInner';

/**
 * 
 * @export
 * @interface GetCustomerPromotions200Response
 */
export interface GetCustomerPromotions200Response {
    /**
     * 
     * @type {Array<GetCustomerPromotions200ResponseItemsInner>}
     * @memberof GetCustomerPromotions200Response
     */
    items: Array<GetCustomerPromotions200ResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200Response
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200Response
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200Response
     */
    itemsPerPage: number;
}

/**
 * Check if a given object implements the GetCustomerPromotions200Response interface.
 */
export function instanceOfGetCustomerPromotions200Response(value: object): value is GetCustomerPromotions200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    return true;
}

export function GetCustomerPromotions200ResponseFromJSON(json: any): GetCustomerPromotions200Response {
    return GetCustomerPromotions200ResponseFromJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerPromotions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetCustomerPromotions200ResponseItemsInnerFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'itemsPerPage': json['itemsPerPage'],
    };
}

export function GetCustomerPromotions200ResponseToJSON(json: any): GetCustomerPromotions200Response {
    return GetCustomerPromotions200ResponseToJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseToJSONTyped(value?: GetCustomerPromotions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(GetCustomerPromotions200ResponseItemsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'itemsPerPage': value['itemsPerPage'],
    };
}

